import { CostModal } from 'components/modal';
import { Theme } from 'themes';

import { EDUCATION_STRINGS } from '../../../education.strings';

import { StartPhdHard } from './start-phd-hard';

import { useStartTest, IStartTestProps } from './start-test.state';

const { START_BUTTON, STOP_BUTTON, TITLE } = EDUCATION_STRINGS.START_TEST;

export const StartTest = (props: IStartTestProps) => {
  const { onCloseModal } = props;

  const state = useStartTest(props);

  if (!state) {
    return null;
  }

  const { energy, money, isLoading, isPhdHard, isGamifiedLevel, onStartTest } =
    state;

  const title = isGamifiedLevel
    ? 'Balance academics, employability, and your social life to be a future-ready graduate!'
    : TITLE;

  if (isPhdHard) {
    return (
      <StartPhdHard
        energy={energy}
        money={money}
        isLoading={isLoading}
        onNext={onStartTest}
        onClose={onCloseModal}
      />
    );
  }

  return (
    <CostModal
      cancelButtonTitle={STOP_BUTTON}
      confirmButtonTitle={START_BUTTON}
      energy={energy}
      money={money}
      onConfirm={onStartTest}
      onCloseModal={onCloseModal}
      onCancel={onCloseModal}
      title={<Theme.Paragraph>{title}</Theme.Paragraph>}
    />
  );
};
